export default {
  balance(state) {
    return state.balance;
  },
  balanceNotFound(state) {
    return state.balanceNotFound;
  },
  balanceError(state) {
    return state.balanceError;
  },
  partners(state) {
    return state.partners;
  },
  partner(state) {
    return state.partner;
  },
  bankAccounts(state) {
    return state.bankAccounts;
  },
  bankAccount(state) {
    return state.bankAccount;
  },
  status(state) {
    return state.status;
  },
  balanceOperations(state) {
    return state.balanceOperations;
  },
};
